import styled, { css } from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'

export const StyledToastWrapper = styled.div`
    bottom: 0;
    left: 50%;
    position: fixed;
    transform: translate(-50%, 0%);
    z-index: 900;
    max-width: 420px;
`

export const StyledToast = styled.div`
    ${({ theme }) => css`
        @keyframes toast-in-bottom {
            to {
                transform: translate(0%, 0%);
            }
            from {
                transform: translate(0%, 100%);
            }
        }
        animation: toast-in-bottom 0.3s;
        background: rgba(255, 255, 255, 0.94);
        border-radius: 4px;
        bottom: 12px;
        box-shadow: -1px 1px 5px 1px rgb(0 0 0 / 10%);
        font-size: 12px;
        padding: ${ThemeSelectors.getLegacyGridUnit(theme) * 2}px ${ThemeSelectors.getLegacyGridUnit(theme) * 6}px;
        transform: translate(0%, 0%);
        transition: transform 0.6s ease-in;
        width: 100%;
        z-index: 3;
        margin: 0 auto ${ThemeSelectors.getGridUnit(theme)};
    `}
`

export const StyledToastDefaultMessage = styled.div`
    & > span:first-child {
        display: inline-block;
        fill: ${({ theme }) => theme.color.bgFill.notification};
        height: 16px;
        vertical-align: middle;
        width: 16px;
    }
    & p,
    & a {
        font-size: 13px;
        line-height: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
        white-space: nowrap;
    }
    align-items: center;
    display: flex;
    gap: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 0.5}px;
    justify-content: center;
    @media (max-width: 420px) {
        align-items: flex-start;
    }
`
